import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import axios from "axios";
import { MdDeleteForever } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import Navbar from '../Navbar.js';
import { toast } from 'react-toastify';
import { TbListDetails } from "react-icons/tb";
import { IoHome } from "react-icons/io5";
import { MdAddToPhotos } from "react-icons/md";
import Menu_Items from '../Menu_Items.js';


function Companies() {
  const [companydetails, setcompanydetails] = useState({});
  const [sortOrder, setSortOrder] = useState("asc"); // Track sorting order
  const [delete_box, setdelete_box] = useState(false);
  const [delete_id, setdelete_id] = useState(null)

  // Function to handle sorting
  const handleSort = (name) => {
    const newOrder = sortOrder === "asc" ? "desc" : "asc"; // Toggle order
    const sorted = [...companydetails].sort((a, b) => {
      if (typeof a[name] === "string") {
        return newOrder === "asc"
          ? a[name].localeCompare(b[name])
          : b[name].localeCompare(a[name]);
      } else {
        return newOrder === "asc" ? a[name] - b[name] : b[name] - a[name]; // Numerical sorting
      }
    })
    setcompanydetails(sorted);
    setSortOrder(newOrder);
  };
  const getcompany = async () => {
    await axios.get("/company").then((res) => {
      if (res.data !== "") {
        setcompanydetails(res.data);
      }
    })
      .catch((err) => {
        toast.error("Error", {
          autoClose: 2000, // 2 seconds
        });
      })
  };
  const del = async () => {
    await axios.delete(`/company/${delete_id}`).then((res) => {
      setdelete_box(false)
      setdelete_id(null)
      getcompany();
    })
      .catch(() => {
        toast.error("Error", {
          autoClose: 2000, // 2 seconds
        });
      });
  };
  useEffect(() => {
    getcompany();
  }, []);
  // console.log(companydetails);
  return (
    <>
      <div className='container df fdc ac'>
        <Navbar />
        <div className='main_box df'>
          <Menu_Items />
          <div className='content df fdc ac'>
            <div className='page_header df jb ac'>
              <div className='w90 df ac'>
                <IoHome className='page_icon db' />
                <p>Company</p></div>
              <Link to={"/company/add"} className='w5' ><MdAddToPhotos className='icon3 g' /></Link>
            </div>
            <table className='df fdc ac box'>
              <thead>
                <tr className='df js ac' style={{ cursor: "pointer" }}>
                  <th onClick={() => { handleSort('name') }} >Company Name {sortOrder === "asc" ? "▲" : "▼"}</th>
                  <th onClick={() => { handleSort('code') }}>Company Code {sortOrder === "asc" ? "▲" : "▼"}</th>
                  <th onClick={() => { handleSort('no_integration') }}>No Of Integration {sortOrder === "asc" ? "▲" : "▼"}</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {companydetails.length > 0 ? companydetails.map((company, index) => {
                  return (
                    <tr className='df jc ac' key={index}>
                      <td className='df ac jc'>{company.name}</td>
                      <td className='df jc ac'>{company.code}</td>
                      <td className='df jc ac'>{company.no_integration}</td>
                      <td className='df jc ac gap2'>
                        <Link to={`/integ/${company.id}`} className='tooltip' icon-name="Open">
                          <TbListDetails className='icon2  db' />
                        </Link>
                        <Link to={`/company/edit/${company.id}`} className='tooltip' icon-name="Edit"><FaEdit className='icon2 db' /></Link>
                        <Link to={`#`} className='tooltip' icon-name="Delete"><MdDeleteForever onClick={() => { setdelete_box(true); setdelete_id(company.id) }} className='icon2 r' /></Link>
                      </td>
                    </tr>
                  )
                }) : <tr className="h65 df jc ac bnone">
                  <td className="w100 bnone tac no_Records">No Records</td>
                </tr>
                }

              </tbody>
            </table>
          </div>
        </div>
      </div >
      {
        delete_box &&
        <div className='dialog_bg'>
          <div className='delete_box'>
            <h1 className='h5 w80 df ac r'>Delete</h1>
            <p className='h5 w80'>Are You Sure You Want to Delete This Item ?</p>
            <div className='h5 w40 df jb ac'>
              <button className='btn l_black' onClick={() => setdelete_box(false)}>Cancel</button>
              <button className='btn red' onClick={() => del()}>Delete</button>
            </div>
          </div>
        </div>
      }
    </>
  )
}

export default Companies;